import AxiosInstance from './HttpClients/Axios';
import FetchInstance from './HttpClients/Fetch';
import IonicNativeHttpInstance from './HttpClients/IonicNativeHttp';
import CapacitorCommunityHttpInstance from './HttpClients/CapacitorCommunityHttp';
import { EnvironmentVariables } from '../../constants/EnvironmentVariables';

const HttpClients = {
  Axios: AxiosInstance,
  Fetch: FetchInstance,
  IonicNative: IonicNativeHttpInstance,
  CapacitorCommunity: CapacitorCommunityHttpInstance,
};

export interface ClientBase {
  Post<TOut>(options: {
    data: any;
    contentType: string;
    baseUrl?: string;
    serviceUrl?: string;
    methodUrl?: string;
  }): Promise<TOut>;
  Get<TOut>(options: { baseUrl?: string; serviceUrl?: string; methodUrl?: string }): Promise<TOut>;
}

export interface HttpClientResult<T = any> {
  data: T;
  status: number;
  headers: {
    [key: string]: string;
  };
  url: string;
  error?: string | undefined;
  statusText?: string | undefined;
}

class _HttpClientSelector {
  public Selected: ClientBase;
  private static _instance: _HttpClientSelector;

  private Select = (): ClientBase => {
    if (EnvironmentVariables.Is_Mobile) {
      return HttpClients.IonicNative;
    } else {
      return HttpClients.CapacitorCommunity;
    }
  };

  private constructor() {
    this.Selected = this.Select();
  }

  public static Instance() {
    return this._instance || (this._instance = new this());
  }
}

export const HttpClientSelector = _HttpClientSelector.Instance().Selected;
